import WelfarePage from "./page"
import BettingRank from "./subPages/bettingRank"
import { RouteObject } from "react-router-dom"

export const welfareRoutes: RouteObject[] = [
    {
        index:true,
        path:"",
        element: <WelfarePage />
    },
    {
        path: "/welfare/betting-rank",
        element: <BettingRank />,
    },
]
